import { render } from "./AudienceQuestions.vue?vue&type=template&id=507c3f4e"
import script from "./AudienceQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceQuestions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceQuestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "507c3f4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('507c3f4e', __exports__)) {
    api.reload('507c3f4e', __exports__)
  }
  
  module.hot.accept("./AudienceQuestions.vue?vue&type=template&id=507c3f4e", () => {
    api.rerender('507c3f4e', render)
  })

}


export default __exports__